/**
 * InfinitSales - Label Dispatch Service
 * Campaign-style dispatch by label. Backend reuses scheduled_message
 * follow-ups under the hood, so anti-duplicate locks, retries, and
 * 24h-window fallback all come for free.
 */
import api from './api';
import requestCache from './requestCache';

const BASE = '/api/labels';

class LabelDispatchService {
  /**
   * Preview which contacts a dispatch would target (for the modal counter).
   * @param {string} labelId
   * @param {'wa_personal'|'wa_business'|'both'} channelFilter
   */
  async previewRecipients(labelId, channelFilter = 'both') {
    const response = await api.get(`${BASE}/${labelId}/recipients/preview`, {
      params: { channel_filter: channelFilter },
    });
    return response.data;
  }

  /**
   * Create and activate a campaign for the label.
   * @param {string} labelId
   * @param {object} payload
   *   - messages: [{ order, send_time, text?, files?, message_type, ... }]
   *   - schedule: { send_time, recurrence, recurrence_days?, recurrence_day_of_month?, start_date, end_date? }
   *   - channel_filter: 'wa_personal' | 'wa_business' | 'both'
   *   - business_config?: { fallback_template_name?, fallback_template_language?, retry_interval_hours?, max_retries? }
   *   - name?: string
   */
  async dispatch(labelId, payload) {
    const response = await api.post(`${BASE}/${labelId}/dispatch`, payload);
    // O disparo por etapa agenda followups para os contatos da etapa — o
    // FollowupBadge/drawer cacheiam o by-recipient por 20s e ficariam sem o
    // agendamento novo.
    requestCache.invalidate('followupsByRecipient:');
    return response.data;
  }
}

const labelDispatchService = new LabelDispatchService();
export default labelDispatchService;
